import React, { PureComponent } from 'react';

import CustomTooltip from '../CustomTooltip/CustomTooltip';

import iconArrowRight from '../../assets/keyboard_arrow_right-24px.svg';

import './CardLink.scss';

let globalId = 0;

export interface CardLinkProps {
  tooltip?: string;
  title?: string;
  subtitle?: string;
  link: string;
  textLink?: string;
}

export class CardLink extends PureComponent<CardLinkProps> {
  tooltipId = ++globalId;

  render() {
    return (
      <>
        <div className='card-link'>
          <div className='title'>
            {this.props.tooltip ? (
              <CustomTooltip tooltip={this.props.tooltip}>
                <span>{this.props.title}</span>
              </CustomTooltip>
            ) : (
                <span>{this.props.title}</span>
              )}
          </div>
          <div className='subtitle'>{this.props.subtitle}</div>
          {(this.props.textLink || iconArrowRight) && false ? <div className='link-content'>
            <a className='link' href={this.props.link || ''} target='_blank'>
              {this.props.textLink} <img src={iconArrowRight} alt='' />
            </a>
          </div> : <></>}
        </div>
      </>
    );
  }
}
